module.exports = __webpack_public_path__ + "img/ar.bd8082ef.jpg";